import * as CONSTANTS from 'constants';
import {ReduxAction} from 'types/Actions';


export type ON_SEARCH_CHANGE = 'ON_SEARCH_CHANGE';
export const ON_SEARCH_CHANGE: ON_SEARCH_CHANGE = 'ON_SEARCH_CHANGE';
export type OnSearchChangeAction = {
	type: ON_SEARCH_CHANGE,
	searchText: string
}
export function onSearchChange(searchText: string): OnSearchChangeAction{
	return {type: ON_SEARCH_CHANGE, searchText};
}

export type ON_PAGE_CHANGE = 'ON_CHANGE_PAGE';
export const ON_PAGE_CHANGE: ON_PAGE_CHANGE = 'ON_CHANGE_PAGE';
export type OnPageChangeAction = {
	type: ON_PAGE_CHANGE,
	page: string
}
export function onPageChange(nextPage: string): OnPageChangeAction{
	return {type: ON_PAGE_CHANGE, page: nextPage}
}

export type SET_MOUSE_SIDE = 'SET_MOUSE_SIDE';
export const SET_MOUSE_SIDE: SET_MOUSE_SIDE = 'SET_MOUSE_SIDE';
export type SetMouseSideAction = {
	type: SET_MOUSE_SIDE,
	side: number
}
export function setMouseSide(side: number): SetMouseSideAction{
	return {type: SET_MOUSE_SIDE, side};
}

export type SET_AUTO = 'SET_AUTO';
export const SET_AUTO: SET_AUTO = 'SET_AUTO';
export type SetAutoAction = {
	type: SET_AUTO,
	on: number | null
}
export function setAuto(on=null): SetAutoAction{
	return {type: SET_AUTO, on};
}


export type DEBUG_VAR = 'DEBUG_VAR';
export const DEBUG_VAR: DEBUG_VAR = 'DEBUG_VAR';
export type DebugVarAction = {
	type: DEBUG_VAR,
	data: object
}
export function debugVar(data: object): DebugVarAction{
	return {type: DEBUG_VAR, data};
}